const ActionIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 16C11.75 16.9665 10.9665 17.75 10 17.75C9.0335 17.75 8.25 16.9665 8.25 16C8.25 15.0335 9.0335 14.25 10 14.25C10.9665 14.25 11.75 15.0335 11.75 16ZM17.75 16C17.75 16.9665 16.9665 17.75 16 17.75C15.0335 17.75 14.25 16.9665 14.25 16C14.25 15.0335 15.0335 14.25 16 14.25C16.9665 14.25 17.75 15.0335 17.75 16ZM22 17.75C22.9665 17.75 23.75 16.9665 23.75 16C23.75 15.0335 22.9665 14.25 22 14.25C21.0335 14.25 20.25 15.0335 20.25 16C20.25 16.9665 21.0335 17.75 22 17.75Z"
        fill={"currentColor"}
      />
    </svg>
  );
};

export default ActionIcon;
